<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { VueContentLoading } from 'vue-content-loading';
import { mapActions, mapGetters } from "vuex";
import AlertError from '@/components/alert_error'
import CountryFlag from 'vue-country-flag'
import Basic from "@/components/maps/leaflet/basic";

export default {
  page: {
    title: "نشاط المدراء",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, VueContentLoading, AlertError, CountryFlag, Basic },
  data() {
    return {
      
      // title
      title: "نشاط المدراء",
      items: [
        {
        text: "الرئيسية",
        href: "/",
        },
        {
        text: "نشاط المدراء",
        active: true,
        },
      ],

      //Page errors.
      errors: [],

      loadingContent: true,
      
      // datatable
      sortDirection: 'user.name',
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50 ,100,{value: Number.MAX_SAFE_INTEGER,text: "عرض الكل"}],
      filter: null,
      filterOn: [],
      sortBy: "date",
      sortDesc: true,
      fields: [
          {
            label: 'ت',
            key: "index",
            sortable: false,
          },
          {
            label: 'اسم المدير',
            key: "user.name",
            sortable: true,
          },
          {
            label: 'تاريخ الاضافة',
            key: "user.created_at",
            sortable: true,
          },
          {
            label: 'تسجيلات الدخول',
            key: "date",
            sortable: true,
          },
          {
            label: 'عنوان ip',
            key: "ip_address",
            sortable: true,
          },
          {
            label: 'تفاصيل متصفح الويب',
            key: "user_agent",
            sortable: true,
          },
          {
            label: 'المنطقة',
            key: "geo_info.region",
            sortable: true,
          },
          {
            label: 'المدينة',
            key: "geo_info.city",
            sortable: true,
          },
          {
            label: 'الدولة',
            key: "geo_info.country",
            sortable: true,
          },
          {
            label: 'الدولة',
            key: "countryFlag",
            sortable: true,
          },
          {
            label: 'التفاصيل',
            key: "details",
            sortable: false,
          },
      ]
    };
  },  
  computed: {
    ...mapGetters('log', ['getLogs']),
    rows() {
      return this.getLogs.length;
    },
  },
  methods: {
    handleError(error){
      alert(error)
      if(error.response.status == 422) this.errors = Object.values(error.response.data.errors)
      else this.errors = [`Error Code : ${error.response.status}  Message : ${error.response.data.message}`]
    },
    ...mapActions("log", ['getAll']),
    // datatable
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    fetchAll(){
      this.getAll({
        all:1,
        order: 'desc'
      }).then(()=>this.loadingContent = false)
      .catch((error)=>{
        this.handleError(error)
        this.loadingContent = false
      })
    }
  },
  created(){
    this.fetchAll()
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <AlertError :errors="errors"></AlertError>

        <div class="card">
          <div class="card-body">

            <div v-if="!loadingContent" class="row mt-3">
              <div class="col-12">

                <div class="row mt-1">

                  <b-form-group class="col-md-3 col-sm-12 mb-3" label="اختر عدد المدخلات لعرضها :" label-for="tickets-table_length">
                    <div id="tickets-table_length" class="dataTables_length">
                      <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm" :options="pageOptions"></b-form-select>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-3 col-sm-12 mb-3" label="البحث :" label-for="filter-input">
                    <b-input-group>
                      <b-form-input class="form-control form-control-sm" id="filter-input" v-model="filter" type="search"  placeholder="بحث ..." ></b-form-input>
                      <b-input-group-append>
                        <b-button class="btn-sm" :disabled="!filter" @click="filter = ''">الغاء</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>

                  <b-form-group v-model="sortDirection" class="col-md-6 col-sm-12 mb-3" label="البحث حسب الحقول :" label-for="filter-on" v-slot="{ ariaDescribedby }">
                    <b-form-checkbox-group class="all-check" id="filter-on" v-model="filterOn" :aria-describedby="ariaDescribedby" >
                      <b-form-checkbox class="check-dis" value="user.name"> الاسم </b-form-checkbox>
                      <b-form-checkbox class="check-dis" value="user.created_at"> تاريخ الاضافة </b-form-checkbox>
                      <b-form-checkbox class="check-dis" value="date"> تسجيلات الدخول </b-form-checkbox>
                      <b-form-checkbox class="check-dis" value="ip_address"> عنوان ip </b-form-checkbox>
                      <b-form-checkbox class="check-dis" value="user_agent"> التفاصيل </b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>

                </div>

                <!-- Table -->
                <div class="table-responsive mb-0">
                    <b-table
                        class="datatables"
                        hover 
                        :items="getLogs" 
                        :fields="fields" 
                        responsive="md" 
                        :per-page="perPage" 
                        :current-page="currentPage" 
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc" 
                        :filter="filter" 
                        :filter-included-fields="filterOn" 
                        @filtered="onFiltered">
                      
                      <!-- A virtual column -->
                      <template #cell(index)="data">
                        {{ (currentPage-1) * perPage + (data.index + 1) }}
                      </template>

                      <template #cell(countryFlag)="data">
                        <country-flag :country='data.item.geo_info.countryCode' size='normal'/>
                      </template>

                      <template #cell(details)="row">
                        <b-button size="sm" @click="row.toggleDetails">
                          {{ row.detailsShowing ? 'اخفاء' : 'عرض' }} التفاصيل
                        </b-button>
                      </template>

                      <template #row-details="row">
                        <b-card>
                          <b-row>
                            <b-col cols="8">
                              <Basic class="leaflet-map" :lat="row.item.geo_info.latitude" :lng="row.item.geo_info.longitude"/>
                            </b-col>
                            <b-col cols="4">
                              <table>
                                <tr><td class="text-primary aline-text-left pb-3">اسم المدير :</td><td class="pb-3 text-info">{{row.item.user.name}}</td></tr>
                                <tr><td class="text-primary aline-text-left pb-3">تاريخ الاضافة :</td><td class="pb-3 text-info">{{row.item.user.created_at}}</td></tr>
                                <tr><td class="text-primary aline-text-left pb-3">تسجيل الدخول :</td><td class="pb-3 text-info">{{row.item.date}}</td></tr>
                                <tr><td class="text-primary aline-text-left pb-3">عنوان IP :</td><td class="pb-3 text-info">{{row.item.ip_address}}</td></tr>
                                <tr><td class="text-primary aline-text-left pb-3">تفاصيل متصفح الويب :</td><td class="pb-3 text-info">{{row.item.user_agent}}</td></tr>
                                <tr><td class="text-primary aline-text-left pb-3">المنطقة :</td><td class="pb-3 text-info">{{row.item.geo_info.region}}</td></tr>
                                <tr><td class="text-primary aline-text-left pb-3">المدينة :</td><td class="pb-3 text-info">{{row.item.geo_info.city}}</td></tr>
                                <tr><td class="text-primary aline-text-left pb-3">الدولة :</td>
                                  <td class="pb-3 text-info d-flex">
                                    <span class="mt-2">{{row.item.geo_info.country}}</span>
                                    <country-flag class="country-flag-details" :country='row.item.geo_info.countryCode' size="big"/>
                                  </td>
                                </tr>
                                <tr><td class="text-primary aline-text-left pb-3">خط الطول :</td><td class="pb-3 text-info">{{row.item.geo_info.longitude}}</td></tr>
                                <tr><td class="text-primary aline-text-left pb-3">خط العرض :</td><td class="pb-3 text-info">{{row.item.geo_info.latitude}}</td></tr>
                              </table>
                            </b-col>
                          </b-row>
                        </b-card>
                      </template>
                    </b-table>
                </div>

                <!-- Footer Table -->
                <div class="row">
                    <div class="col">
                        <div class="dataTables_paginate paging_simple_numbers float-end">
                            <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>   
              </div>
            </div>

            <!-- loading content -->
            <div v-else>
              <vue-content-loading :rtl="true" :width="400" :height="90">
                <rect x="0" y="5" rx="1" ry="1" width="30" height="2" />
                <rect x="101" y="5" rx="1" ry="1" width="30" height="2" />
                <rect x="203" y="5" rx="1" ry="1" width="30" height="2" />
                <rect x="0" y="9" rx="1" ry="1" width="95" height="5" />
                <rect x="101" y="9" rx="1" ry="1" width="96" height="5" />
                <rect x="203" y="9" rx="1" ry="1" width="197" height="5" />

                <rect x="0" y="25" rx="2" ry="2" width="71" height="5" />
                <rect x="82" y="25" rx="2" ry="2" width="71" height="5" />
                <rect x="164" y="25" rx="2" ry="2" width="71" height="5" />
                <rect x="246" y="25" rx="2" ry="2" width="71" height="5" />
                <rect x="328" y="25" rx="2" ry="2" width="72" height="5" />
                <rect x="0" y="34" rx="1" ry="1" width="400" height="1" />

                <rect x="0" y="39" rx="2" ry="2" width="71" height="5" />
                <rect x="82" y="39" rx="2" ry="2" width="71" height="5" />
                <rect x="164" y="39" rx="2" ry="2" width="71" height="5" />
                <rect x="246" y="39" rx="2" ry="2" width="71" height="5" />
                <rect x="328" y="39" rx="2" ry="2" width="72" height="5" />
                
                <rect x="0" y="48" rx="1" ry="1" width="400" height="1" />

                <rect x="0" y="53" rx="2" ry="2" width="71" height="5" />
                <rect x="82" y="53" rx="2" ry="2" width="71" height="5" />
                <rect x="164" y="53" rx="2" ry="2" width="71" height="5" />
                <rect x="246" y="53" rx="2" ry="2" width="71" height="5" />
                <rect x="328" y="53" rx="2" ry="2" width="72" height="5" />
                
                <rect x="0" y="62" rx="1" ry="1" width="400" height="1" />

                <rect x="0" y="67" rx="2" ry="2" width="71" height="5" />
                <rect x="82" y="67" rx="2" ry="2" width="71" height="5" />
                <rect x="164" y="67" rx="2" ry="2" width="71" height="5" />
                <rect x="246" y="67" rx="2" ry="2" width="71" height="5" />
                <rect x="328" y="67" rx="2" ry="2" width="72" height="5" />
                
                <rect x="0" y="76" rx="1" ry="1" width="400" height="1" />
                <circle cx="350" cy="85" r="1" />
                <circle cx="360" cy="85" r="1" />
                <circle cx="373" cy="85" r="4" />
                <circle cx="386" cy="85" r="1" />
                <circle cx="396" cy="85" r="1" />
              </vue-content-loading>
            </div>

          </div>
        </div>
      </div>

    </div>
    
  </Layout>
</template>